import { VoteAIRecommendationRequest, VoteAIRecommendationResponse } from '../voteairecommendation';
import * as _m0 from "protobufjs/minimal";
import { withAuthRetry } from '../utils/authRetry';

export async function voteAIRecommendation(
    caseId: string,
    aiRecommendationId: string,
    accessToken: string,
    setAccessToken: (token: string | null) => void,
    logout: () => void
): Promise<VoteAIRecommendationResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const request: VoteAIRecommendationRequest = {
            caseId: caseId,
            aiRecommendationId: aiRecommendationId
        };

        const encodedRequest = VoteAIRecommendationRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        const params = new URLSearchParams(window.location.search);
        const staging = params.get('stagingEnv')?.toLowerCase() === 'true';

        let url = "https://li68ja5qo4.execute-api.us-west-2.amazonaws.com/intakeservice/voteairecommendation";
        if (staging) {
            url = `${url}-staging`;
        }

        const response = await fetch(
            url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: base64
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): VoteAIRecommendationResponse => {
        return VoteAIRecommendationResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
